import React, {
    useEffect,
    useState,
  } from "react";
  
  import {
    useNavigate,
    useLocation,
  } from "react-router-dom";
  
  import {
    collection,
    query,
    where,
    onSnapshot,
  } from "firebase/firestore";
  
  import { db } from "../firebase";
  
  import {
    FaArrowLeft,
    FaMobileAlt,
    FaBuilding,
    FaCopy,
    FaCheckCircle,
    FaWallet,
    FaClock,
    FaMoneyBillWave,
    FaShieldAlt,
    FaBook,
    FaGlobeAfrica,
  } from "react-icons/fa";
  
  import "./BfcMobilePayment.css";
  
  
  /* =========================================================
     COUNTRY DEPOSIT INSTRUCTIONS
  
     Tanzania haitumii hizi instructions.
     Tanzania ina confirmation flow yake.
  
     Nchi nyingine zinatumia instructions hizi.
  ========================================================= */
  
  const countryMethods = {
  
    Kenya: [
      {
        network:
          "Safaricom or Airtel",
  
        ussd:
          "*840#",
  
        steps: [
          "Select (1) Send Money To Abroad",
          "Select (1) Send to Mobile Number",
          "Select (3) Send to Tanzania",
          "Select Network (Enter Vodacom/M-Pesa)",
          "Enter recipient mobile number shown below in international format",
          "Enter the exact deposit amount shown below in KES",
          "Select (2) Business or Investment",
          "Select (1) Confirm and enter Your PIN",
          "Submit / Confirm",
        ],
      },
    ],
  
  
    Uganda: [
      {
        network:
          "Airtel or MTN",
  
        ussd:
          "*165#",
  
        steps: [
          "Select Send Money",
          "Select International Transfer",
          "Select Tanzania",
          "Select Network (Enter Vodacom/M-Pesa)",
          "Enter recipient mobile number shown below",
          "Enter the exact deposit amount shown below in UGX",
          "Select Business or Investment if the option appears",
          "Confirm with PIN",
          "Submit / Confirm",
        ],
      },
    ],
  
  
    Rwanda: [
      {
        network:
          "Airtel or MTN",
  
        ussd:
          "*182#",
  
        steps: [
          "Select Send Money",
          "Select International Transfer",
          "Select Tanzania",
          "Select Network (Enter Vodacom/M-Pesa)",
          "Enter recipient mobile number shown below",
          "Enter the exact deposit amount shown below in RWF",
          "Select Business or Investment if the option appears",
          "Confirm with PIN",
          "Submit / Confirm",
        ],
      },
    ],
  
  
    Burundi: [
      {
        network:
          "Ecocash or Lumicash",
  
        ussd:
          "",
  
        steps: [
          "Dial Ecocash or Lumicash USSD",
          "Select International Transfer",
          "Select Tanzania",
          "Select Network (Enter Vodacom/M-Pesa)",
          "Enter recipient mobile number shown below",
          "Enter the exact deposit amount shown below in BIF",
          "Select Business or Investment if the option appears",
          "Confirm with PIN",
          "Submit / Confirm",
        ],
      },
    ],
  
  
    "DRC - Congo": [
      {
        network:
          "Vodacom M-Pesa / Airtel / Orange / Illico Cash",
  
        ussd:
          "",
  
        steps: [
          "Dial your mobile money USSD",
          "Select Send Money",
          "Select International",
          "Select Tanzania",
          "Select Network (Enter Vodacom/M-Pesa)",
          "Enter recipient mobile number shown below",
          "Enter the exact deposit amount shown below in USD",
          "Select Business or Investment if the option appears",
          "Confirm with PIN",
          "Submit / Confirm",
        ],
      },
    ],
  
  
    "DR Congo": [
      {
        network:
          "Vodacom M-Pesa / Airtel / Orange / Illico Cash",
  
        ussd:
          "",
  
        steps: [
          "Dial your mobile money USSD",
          "Select Send Money",
          "Select International",
          "Select Tanzania",
          "Select Network (Enter Vodacom/M-Pesa)",
          "Enter recipient mobile number shown below",
          "Enter the exact deposit amount shown below in CDF",
          "Select Business or Investment if the option appears",
          "Confirm with PIN",
          "Submit / Confirm",
        ],
      },
    ],
  
  
    Zambia: [
      {
        network:
          "Airtel / MTN / Zamtel",
  
        ussd:
          "*115#",
  
        steps: [
          "Select Send Money",
          "Select Cross Border",
          "Select Tanzania",
          "Select Network (Enter Vodacom/M-Pesa)",
          "Enter recipient mobile number shown below",
          "Enter the exact deposit amount shown below in ZMW",
          "Select Business or Investment if the option appears",
          "Confirm with PIN",
          "Submit / Confirm",
        ],
      },
    ],
  
  
    Malawi: [
      {
        network:
          "Airtel / TNM",
  
        ussd:
          "*211#",
  
        steps: [
          "Select International Transfer",
          "Select Tanzania",
          "Select Network (Enter Vodacom/M-Pesa)",
          "Enter recipient mobile number shown below",
          "Enter the exact deposit amount shown below in MWK",
          "Select Business or Investment if the option appears",
          "Confirm with PIN",
          "Submit / Confirm",
        ],
      },
    ],
  
  
    Mozambique: [
      {
        network:
          "Vodacom",
  
        ussd:
          "",
  
        steps: [
          "Dial M-Pesa USSD",
          "Select Send Money",
          "Select International Transfer",
          "Select Tanzania",
          "Select Network (Enter Vodacom/M-Pesa)",
          "Enter recipient mobile number shown below",
          "Enter the exact deposit amount shown below in MZN",
          "Select Business or Investment if the option appears",
          "Confirm with PIN",
          "Submit / Confirm",
        ],
      },
    ],
  
  
    Zimbabwe: [
      {
        network:
          "EcoCash",
  
        ussd:
          "*151#",
  
        steps: [
          "Select Send Money",
          "Select International Transfer",
          "Select Tanzania",
          "Select Network (Enter Vodacom/M-Pesa)",
          "Enter recipient mobile number shown below",
          "Enter the exact deposit amount shown below in USD",
          "Select Business or Investment if the option appears",
          "Confirm with PIN",
          "Submit / Confirm",
        ],
      },
    ],
  
  
    "South Sudan": [
      {
        network:
          "MGurush / MTN",
  
        ussd:
          "",
  
        steps: [
          "Select International Transfer",
          "Select Tanzania",
          "Enter recipient mobile number shown below",
          "Select Network (Enter Vodacom/M-Pesa)",
          "Enter the exact deposit amount shown below in SSP",
          "Select Business or Investment if the option appears",
          "Confirm with PIN",
          "Submit / Confirm",
        ],
      },
    ],
  
  
    Botswana: [
      {
        network:
          "Orange / BTC / Mascom",
  
        ussd:
          "",
  
        steps: [
          "Select International Transfer",
          "Select Tanzania",
          "Enter recipient mobile number shown below",
          "Select Network (Enter Vodacom/M-Pesa)",
          "Enter the exact deposit amount shown below in BWP",
          "Select Business or Investment if the option appears",
          "Confirm with PIN",
          "Submit / Confirm",
        ],
      },
    ],
  
  
    Madagascar: [
      {
        network:
          "Airtel / Orange",
  
        ussd:
          "",
  
        steps: [
          "Select International Transfer",
          "Select Tanzania",
          "Select Network (Enter Vodacom/M-Pesa)",
          "Enter recipient mobile number shown below",
          "Enter the exact deposit amount shown below in MGA",
          "Select Business or Investment if the option appears",
          "Confirm with PIN",
          "Submit / Confirm",
        ],
      },
    ],
  
  };
  
  
  /* =========================================================
     COMPONENT
  ========================================================= */
  
  export default function MobilePayment() {
  
    const navigate =
      useNavigate();
  
    const { state } =
      useLocation();
  
  
    /* =========================================================
       PAYMENT DATA
    ========================================================= */
  
    const provider =
      state?.provider || "";
  
  
    const amount =
      state?.amount || "";
  
  
    /* =========================================================
       COUNTRY
    ========================================================= */
  
    const country =
      typeof state?.country === "object"
  
        ? state?.country?.name ||
          state?.countryName ||
          "Tanzania"
  
        : state?.country ||
          state?.countryName ||
          "Tanzania";
  
  
    /* =========================================================
       CURRENCY
    ========================================================= */
  
    const currency =
      state?.currency ||
  
      (
        typeof state?.country === "object"
          ? state?.country?.currency
          : ""
      ) ||
  
      "TZS";
  
  
    /* =========================================================
       RATE
    ========================================================= */
  
    const rate =
      Number(
        state?.rate ??
        state?.exchangeRate ??
        0
      );
  
  
    /* =========================================================
       RECEIVE AMOUNT
    ========================================================= */
  
    const receiveAmount =
      Number(
        state?.receiveAmount ??
        state?.usdtAmount ??
        0
      );
  
  
    const receiveCurrency =
      state?.receiveCurrency ||
      "USDT";
  
  
    const minimumAmount =
      Number(
        state?.minimumAmount || 0
      );
  
  
    /* =========================================================
       FLAG
    ========================================================= */
  
    const flag =
      state?.flag ||
  
      (
        typeof state?.country === "object"
          ? state?.country?.flag
          : ""
      ) ||
  
      "";
  
  
    /* =========================================================
       TANZANIA CHECK
    ========================================================= */
  
    const isTanzania =
      String(country)
        .trim()
        .toLowerCase() ===
      "tanzania";
  
  
    /* =========================================================
       COUNTRY DEPOSIT INSTRUCTIONS
    ========================================================= */
  
    const countryInstructions =
      countryMethods[country] ||
      countryMethods[
        String(country).trim()
      ] ||
      null;
  
  
    /* =========================================================
       ACCOUNT TYPE
    ========================================================= */
  
    const [
      accountType,
      setAccountType,
    ] = useState("normal");
  
  
    /* =========================================================
       TANZANIA NORMAL ACCOUNT
    ========================================================= */
  
    const [
      currentNormal,
      setCurrentNormal,
    ] = useState(null);
  
  
    /* =========================================================
       TANZANIA BUSINESS ACCOUNT
    ========================================================= */
  
    const [
      currentBusiness,
      setCurrentBusiness,
    ] = useState(null);
  
  
    /* =========================================================
       OTHER COUNTRY ACCOUNT
    ========================================================= */
  
    const [
      currentOtherCountry,
      setCurrentOtherCountry,
    ] = useState(null);
  
  
    /* =========================================================
       COPY STATE
    ========================================================= */
  
    const [
      copied,
      setCopied,
    ] = useState(false);
  
  
    /* =========================================================
       FIREBASE PROVIDER
       
       Tanzania ONLY
    ========================================================= */
  
    const firebaseProvider =
      String(provider)
        .toLowerCase()
        .includes("vodacom")
  
        ? "Vodacom"
  
        : String(provider)
            .toLowerCase()
            .includes("airtel")
  
        ? "Airtel"
  
        : String(provider)
            .toLowerCase()
            .includes("yas")
  
        ? "Tigo"
  
        : String(provider)
            .toLowerCase()
            .includes("tigo")
  
        ? "Tigo"
  
        : String(provider)
            .toLowerCase()
            .includes("halotel")
  
        ? "Halotel"
  
        : provider;
  
  
    /* =========================================================
       COPY TEXT
    ========================================================= */
  
    const copyText = async (
      text
    ) => {
  
      if (!text) {
        return;
      }
  
  
      try {
  
        setCopied(false);
  
  
        const value =
          String(text);
  
  
        /* =====================================================
           MODERN CLIPBOARD
        ===================================================== */
  
        if (
          navigator.clipboard &&
          window.isSecureContext
        ) {
  
          await navigator.clipboard.writeText(
            value
          );
  
        }
  
  
        /* =====================================================
           MOBILE FALLBACK
        ===================================================== */
  
        else {
  
          const textArea =
            document.createElement(
              "textarea"
            );
  
  
          textArea.value =
            value;
  
  
          textArea.style.position =
            "fixed";
  
  
          textArea.style.left =
            "-9999px";
  
  
          textArea.style.top =
            "0";
  
  
          textArea.style.width =
            "1px";
  
  
          textArea.style.height =
            "1px";
  
  
          textArea.style.opacity =
            "0";
  
  
          textArea.style.pointerEvents =
            "none";
  
  
          textArea.setAttribute(
            "readonly",
            ""
          );
  
  
          document.body.appendChild(
            textArea
          );
  
  
          textArea.focus();
  
          textArea.select();
  
  
          textArea.setSelectionRange(
            0,
            value.length
          );
  
  
          const successful =
            document.execCommand(
              "copy"
            );
  
  
          document.body.removeChild(
            textArea
          );
  
  
          if (!successful) {
  
            throw new Error(
              "Copy command failed"
            );
  
          }
  
        }
  
  
        setCopied(true);
  
  
        setTimeout(() => {
  
          setCopied(false);
  
        }, 2200);
  
      }
  
      catch (error) {
  
        console.error(
          "Copy failed:",
          error
        );
  
  
        alert(
          "Failed to copy. Please try again."
        );
  
      }
  
    };
  
  
    /* =========================================================
       FIREBASE REALTIME LISTENER
       
       TANZANIA:
         normalNumbers
         depositNumbers
  
       OTHER:
         othercountry
    ========================================================= */
  
    useEffect(() => {
  
      /* =======================================================
         RESET
      ======================================================= */
  
      setCurrentNormal(null);
  
      setCurrentBusiness(null);
  
      setCurrentOtherCountry(null);
  
  
      /* =======================================================
         OTHER COUNTRIES
         
         Collection:
         othercountry
      ======================================================= */
  
      if (!isTanzania) {
  
        const otherCountryRef =
          collection(
            db,
            "othercountry"
          );
  
  
        const unsubscribeOtherCountry =
          onSnapshot(
  
            otherCountryRef,
  
            (snapshot) => {
  
              const list =
                snapshot.docs
                  .map(
                    (item) => {
  
                      const data =
                        item.data();
  
  
                      return {
  
                        id:
                          item.id,
  
                        ...data,
  
  
                        /* ================================
                           NAME SUPPORT
                        ================================= */
  
                        fullname:
                          data.fullname ||
                          data.name ||
                          "",
  
  
                        /* ================================
                           NUMBER SUPPORT
                        ================================= */
  
                        number:
                          data.number ||
                          "",
  
                      };
  
                    }
                  )
                  .filter(
                    (item) =>
                      item.number
                  );
  
  
              /* =============================================
                 RANDOM ACCOUNT
              ============================================= */
  
              if (
                list.length > 0
              ) {
  
                const randomIndex =
                  Math.floor(
                    Math.random() *
                    list.length
                  );
  
  
                setCurrentOtherCountry(
                  list[randomIndex]
                );
  
              }
  
              else {
  
                setCurrentOtherCountry(
                  null
                );
  
              }
  
            },
  
            (error) => {
  
              console.error(
                "Other country account error:",
                error
              );
  
  
              setCurrentOtherCountry(
                null
              );
  
            }
  
          );
  
  
        return () => {
  
          unsubscribeOtherCountry();
  
        };
  
      }
  
  
      /* =======================================================
         TANZANIA NORMAL
      ======================================================= */
  
      const normalRef =
        collection(
          db,
          "normalNumbers"
        );
  
  
      /* =======================================================
         TANZANIA BUSINESS
      ======================================================= */
  
      const businessRef =
        collection(
          db,
          "depositNumbers"
        );
  
  
      /* =======================================================
         NORMAL QUERY
      ======================================================= */
  
      const normalQuery =
        query(
          normalRef,
          where(
            "provider",
            "==",
            firebaseProvider
          )
        );
  
  
      /* =======================================================
         BUSINESS QUERY
      ======================================================= */
  
      const businessQuery =
        query(
          businessRef,
          where(
            "provider",
            "==",
            firebaseProvider
          )
        );
  
  
      /* =======================================================
         NORMAL ACCOUNT
      ======================================================= */
  
      const unsubscribeNormal =
        onSnapshot(
  
          normalQuery,
  
          (snapshot) => {
  
            const list =
              snapshot.docs.map(
                (item) => ({
  
                  id:
                    item.id,
  
                  ...item.data(),
  
                })
              );
  
  
            if (
              list.length > 0
            ) {
  
              const randomIndex =
                Math.floor(
                  Math.random() *
                  list.length
                );
  
  
              setCurrentNormal(
                list[randomIndex]
              );
  
            }
  
            else {
  
              setCurrentNormal(
                null
              );
  
            }
  
          },
  
          (error) => {
  
            console.error(
              "Normal account error:",
              error
            );
  
  
            setCurrentNormal(
              null
            );
  
          }
  
        );
  
  
      /* =======================================================
         BUSINESS ACCOUNT
      ======================================================= */
  
      const unsubscribeBusiness =
        onSnapshot(
  
          businessQuery,
  
          (snapshot) => {
  
            const list =
              snapshot.docs.map(
                (item) => ({
  
                  id:
                    item.id,
  
                  ...item.data(),
  
                })
              );
  
  
            if (
              list.length > 0
            ) {
  
              const randomIndex =
                Math.floor(
                  Math.random() *
                  list.length
                );
  
  
              setCurrentBusiness(
                list[randomIndex]
              );
  
            }
  
            else {
  
              setCurrentBusiness(
                null
              );
  
            }
  
          },
  
          (error) => {
  
            console.error(
              "Business account error:",
              error
            );
  
  
            setCurrentBusiness(
              null
            );
  
          }
  
        );
  
  
      /* =======================================================
         CLEANUP
      ======================================================= */
  
      return () => {
  
        unsubscribeNormal();
  
        unsubscribeBusiness();
  
      };
  
    }, [
      isTanzania,
      firebaseProvider,
    ]);
  
  
    /* =========================================================
       CURRENT ACCOUNT
    ========================================================= */
  
    const currentAccount =
      isTanzania
  
        ? (
            accountType === "normal"
              ? currentNormal
              : currentBusiness
          )
  
        : currentOtherCountry;
  
  
    /* =========================================================
       ACCOUNT NAME
    ========================================================= */
  
    const currentAccountName =
      currentAccount?.fullname ||
      currentAccount?.name ||
      "-";
  
  
    /* =========================================================
       ACCOUNT NUMBER
    ========================================================= */
  
    const currentAccountNumber =
      currentAccount?.number ||
      "";
  
  
    /* =========================================================
       COMPLETE PAYMENT
    ========================================================= */
  
    const handleComplete = () => {
  
      /* =====================================================
         NO ACCOUNT
      ===================================================== */
  
      if (
        !currentAccount
      ) {
  
        alert(
          isTanzania
            ? "Wait Payment Account"
            : "No payment number is currently available."
        );
  
        return;
  
      }
  
  
      /* =====================================================
         NO NUMBER
      ===================================================== */
  
      if (
        !currentAccountNumber
      ) {
  
        alert(
          "Payment number is not available."
        );
  
        return;
  
      }
  
  
      /* =====================================================
         TANZANIA
      ===================================================== */
  
      if (isTanzania) {
  
        navigate(
          "/BFCConfirm-deposit",
          {
            state: {
  
              provider:
                provider,
  
              amount:
                amount,
  
              accountType:
                accountType,
  
              number:
                currentAccountNumber,
  
              fullname:
                currentAccountName,
  
            },
  
          }
        );
  
  
        return;
  
      }
  
  
      /* =====================================================
         OTHER COUNTRIES
      ===================================================== */
  
      navigate(
        "/BFCConfirm-deposit",
        {
          state: {
  
            deposit: {
  
              /* =============================================
                 USER
              ============================================= */
  
              username:
                localStorage.getItem(
                  "username"
                ) || "Guest",
  
  
              /* =============================================
                 COUNTRY
              ============================================= */
  
              countryName:
                country,
  
              country:
                country,
  
              flag:
                flag,
  
  
              /* =============================================
                 CURRENCY
              ============================================= */
  
              currency:
                currency,
  
  
              /* =============================================
                 AMOUNT
              ============================================= */
  
              amount:
                Number(
                  amount
                ) || 0,
  
              minimumAmount:
                minimumAmount,
  
  
              /* =============================================
                 RATE
              ============================================= */
  
              rate:
                rate,
  
              exchangeRate:
                rate,
  
  
              /* =============================================
                 USDT RECEIVE
              ============================================= */
  
              receiveAmount:
                receiveAmount,
  
              usdtAmount:
                receiveAmount,
  
              receiveCurrency:
                receiveCurrency,
  
  
              /* =============================================
                 PAYMENT METHOD
              ============================================= */
  
              paymentMethod:
                provider,
  
              provider:
                provider,
  
  
              /* =============================================
                 ACCOUNT
              ============================================= */
  
              accountType:
                "othercountry",
  
              paymentAccountType:
                "othercountry",
  
  
              receivingNumber:
                currentAccountNumber,
  
              receivingName:
                currentAccountName,
  
  
              number:
                currentAccountNumber,
  
              fullname:
                currentAccountName,
  
  
              /* =============================================
                 TYPE
              ============================================= */
  
              type:
                "deposit",
  
              depositMethod:
                "mobile",
  
  
              /* =============================================
                 VERIFICATION
              ============================================= */
  
              excludeVerification:
                false,
  
            },
  
          },
  
        }
      );
  
    };
  
  
    /* =========================================================
       FORMAT AMOUNT
    ========================================================= */
  
    const formattedAmount =
      Number(
        amount || 0
      ).toLocaleString(
        "en-US"
      );
  
  
    const formattedReceiveAmount =
      Number(
        receiveAmount || 0
      ).toFixed(2);
  
  
    /* =========================================================
       RENDER
    ========================================================= */
  
    return (
  
      <div
        className="mobile-payment-page"
      >
  
        {/* =====================================================
            BACK BUTTON
        ===================================================== */}
  
        <button
          type="button"
          className="payment-back-btn"
          onClick={() =>
            navigate(-1)
          }
        >
  
          <FaArrowLeft />
  
          <span>
            Back
          </span>
  
        </button>
  
  
        {/* =====================================================
            MAIN CONTAINER
        ===================================================== */}
  
        <div
          className="mobile-payment-container"
        >
  
          {/* ===================================================
              HEADER
          =================================================== */}
  
          <div
            className="payment-header"
          >
  
            <div
              className="payment-header-content"
            >
  
              <span
                className="payment-badge"
              >
  
                MOBILE PAYMENT
  
              </span>
  
  
              <h1>
                Complete Deposit
              </h1>
  
  
              <p>
                Send the exact amount to the
                payment account below.
              </p>
  
            </div>
  
  
            <div
              className="payment-security-icon"
            >
  
              <FaShieldAlt />
  
            </div>
  
          </div>
  
  
          {/* ===================================================
              PAYMENT SUMMARY
          =================================================== */}
  
          <div
            className="payment-summary"
          >
  
            {/* PROVIDER */}
  
            <div
              className="summary-card"
            >
  
              <div
                className="summary-icon"
              >
  
                <FaMobileAlt />
  
              </div>
  
  
              <div>
  
                <span>
                  PAYMENT METHOD
                </span>
  
  
                <strong>
  
                  {provider ||
                    "Mobile Money"}
  
                </strong>
  
              </div>
  
            </div>
  
  
            {/* AMOUNT */}
  
            <div
              className="summary-card amount-card"
            >
  
              <div
                className="summary-icon"
              >
  
                <FaMoneyBillWave />
  
              </div>
  
  
              <div>
  
                <span>
                  DEPOSIT AMOUNT
                </span>
  
  
                <strong>
  
                  {formattedAmount}{" "}
                  {currency}
  
                </strong>
  
              </div>
  
            </div>
  
          </div>
  
  
          {/* ===================================================
              RECEIVE SUMMARY
          =================================================== */}
  
          <div
            className="payment-summary"
          >
  
            <div
              className="summary-card"
            >
  
              <div
                className="summary-icon"
              >
  
                <FaWallet />
  
              </div>
  
  
              <div>
  
                <span>
                  YOU WILL RECEIVE
                </span>
  
  
                <strong>
  
                  {formattedReceiveAmount}{" "}
                  {receiveCurrency}
  
                </strong>
  
              </div>
  
            </div>
  
  
            <div
              className="summary-card"
            >
  
              <div
                className="summary-icon"
              >
  
                <FaClock />
  
              </div>
  
  
              <div>
  
                <span>
                  EXCHANGE RATE
                </span>
  
  
                <strong>
  
                  1 USDT ={" "}
                  {Number(
                    rate || 0
                  ).toLocaleString(
                    "en-US"
                  )}{" "}
                  {currency}
  
                </strong>
  
              </div>
  
            </div>
  
          </div>
  
  
          {/* ===================================================
              ACCOUNT SECTION
          =================================================== */}
  
          <div
            className="payment-section"
          >
  
            {/* =================================================
                SECTION HEADING
            ================================================= */}
  
            <div
              className="section-heading"
            >
  
              <div>
  
                <span>
                  PAYMENT ACCOUNT
                </span>
  
  
                <h2>
  
                  {isTanzania
                    ? "Choose Account"
                    : "Payment Number"}
  
                </h2>
  
              </div>
  
            </div>
  
  
            {/* =================================================
                TANZANIA ACCOUNT TABS
            ================================================= */}
  
            {isTanzania && (
  
              <div
                className="account-tabs"
              >
  
                {/* NORMAL */}
  
                <button
                  type="button"
                  className={
                    accountType ===
                    "normal"
                      ? "active"
                      : ""
                  }
                  onClick={() => {
  
                    setAccountType(
                      "normal"
                    );
  
                    setCopied(false);
  
                  }}
                >
  
                  <FaMobileAlt />
  
                  <span>
                    Normal Number
                  </span>
  
                </button>
  
  
                {/* BUSINESS */}
  
                <button
                  type="button"
                  className={
                    accountType ===
                    "business"
                      ? "active"
                      : ""
                  }
                  onClick={() => {
  
                    setAccountType(
                      "business"
                    );
  
                    setCopied(false);
  
                  }}
                >
  
                  <FaBuilding />
  
                  <span>
                    Business Account
                  </span>
  
                </button>
  
              </div>
  
            )}
  
  
            {/* =================================================
                OTHER COUNTRY HEADER
            ================================================= */}
  
            {!isTanzania && (
  
              <div
                className="payment-note"
              >
  
                <div
                  className="note-icon"
                >
  
                  <FaGlobeAfrica />
  
                </div>
  
  
                <div
                  className="note-content"
                >
  
                  <span>
  
                    {flag}{" "}
                    {String(
                      country
                    ).toUpperCase()}
  
                  </span>
  
  
                  <p>
  
                    Payment number is provided
                    from our{" "}
  
                    <strong>
                      othercountry
                    </strong>
  
                    {" "}collection.
  
                  </p>
  
                </div>
  
              </div>
  
            )}
  
  
            {/* =================================================
                CURRENT ACCOUNT
            ================================================= */}
  
            {currentAccount ? (
  
              <div
                className="number-box"
              >
  
                {/* ACCOUNT LABEL */}
  
                <div
                  className="account-label"
                >
  
                  <span>
  
                    {isTanzania
  
                      ? (
                          accountType ===
                          "normal"
  
                            ? "NORMAL MOBILE NUMBER"
  
                            : "BUSINESS ACCOUNT"
                        )
  
                      : "OTHER COUNTRY PAYMENT NUMBER"}
  
                  </span>
  
  
                  <FaCheckCircle />
  
                </div>
  
  
                {/* PHONE NUMBER */}
  
                <div
                  className="account-row"
                >
  
                  <div
                    className="row-icon"
                  >
  
                    <FaMobileAlt />
  
                  </div>
  
  
                  <div
                    className="account-info"
                  >
  
                    <span>
                      RECIPIENT NUMBER
                    </span>
  
  
                    <strong>
                      {
                        currentAccountNumber
                      }
                    </strong>
  
                  </div>
  
  
                  {/* COPY */}
  
                  <button
                    type="button"
                    className={
                      copied
                        ? "copy-btn copied"
                        : "copy-btn"
                    }
                    onClick={() =>
                      copyText(
                        currentAccountNumber
                      )
                    }
                    aria-label={
                      copied
                        ? "Number copied"
                        : "Copy phone number"
                    }
                  >
  
                    {copied ? (
  
                      <>
  
                        <FaCheckCircle />
  
                        <span>
                          Copied
                        </span>
  
                      </>
  
                    ) : (
  
                      <>
  
                        <FaCopy />
  
                        <span>
                          Copy
                        </span>
  
                      </>
  
                    )}
  
                  </button>
  
                </div>
  
  
                {/* ACCOUNT NAME */}
  
                <div
                  className="account-row"
                >
  
                  <div
                    className="row-icon"
                  >
  
                    <FaWallet />
  
                  </div>
  
  
                  <div
                    className="account-info"
                  >
  
                    <span>
                      RECIPIENT NAME
                    </span>
  
  
                    <strong>
                      {
                        currentAccountName
                      }
                    </strong>
  
                  </div>
  
                </div>
  
              </div>
  
            ) : (
  
              /* =================================================
                 NO ACCOUNT
              ================================================= */
  
              <div
                className="no-account-box"
              >
  
                <div
                  className="no-account-icon"
                >
  
                  !
  
                </div>
  
  
                <h3>
                  No Account Available
                </h3>
  
  
                <p>
  
                  {isTanzania
  
                    ? (
                        <>
                          There is currently no
                          payment account available
                          for {provider}.
                        </>
                      )
  
                    : (
                        <>
                          There is currently no
                          payment number available
                          for {country}.
                        </>
                      )}
  
                </p>
  
              </div>
  
            )}
  
  
            {/* =================================================
                OTHER COUNTRY PAYMENT DETAILS
            ================================================= */}
  
            {!isTanzania &&
              currentAccount && (
  
                <div
                  className="payment-note"
                >
  
                  <div
                    className="note-icon"
                  >
  
                    <FaMoneyBillWave />
  
                  </div>
  
  
                  <div
                    className="note-content"
                  >
  
                    <span>
                      PAYMENT DETAILS
                    </span>
  
  
                    <p>
  
                      Send exactly{" "}
  
                      <strong>
  
                        {formattedAmount}{" "}
                        {currency}
  
                      </strong>
  
                      {" "}to the number above.
  
                    </p>
  
  
                    <small>
  
                      You will receive approximately{" "}
  
                      <strong>
  
                        {formattedReceiveAmount}{" "}
                        {receiveCurrency}
  
                      </strong>
  
                      {" "}after confirmation.
  
                    </small>
  
                  </div>
  
                </div>
  
              )}
  
  
            {/* =================================================
                DEPOSIT INSTRUCTIONS
                
                OTHER COUNTRIES ONLY
            ================================================= */}
  
            {!isTanzania &&
              countryInstructions &&
              currentAccount && (
  
                <div
                  className="country-instructions"
                >
  
                  {/* ===========================================
                      INSTRUCTION HEADER
                  ============================================ */}
  
                  <div
                    className="country-instructions-header"
                  >
  
                    <div
                      className="country-instructions-icon"
                    >
  
                      <FaBook />
  
                    </div>
  
  
                    <div>
  
                      <span>
                        DEPOSIT INSTRUCTIONS
                      </span>
  
  
                      <h3>
                        How to make payment
                      </h3>
  
                    </div>
  
                  </div>
  
  
                  {/* ===========================================
                      METHODS
                  ============================================ */}
  
                  {countryInstructions.map(
                    (
                      method,
                      methodIndex
                    ) => (
  
                      <div
                        className="country-instruction-card"
                        key={
                          methodIndex
                        }
                      >
  
                        {/* =====================================
                            NETWORK
                        ====================================== */}
  
                        <div
                          className="instruction-info-grid"
                        >
  
                          <div
                            className="instruction-info-item"
                          >
  
                            <span>
                              NETWORK
                            </span>
  
  
                            <strong>
                              {
                                method.network
                              }
                            </strong>
  
                          </div>
  
  
                          {/* ===================================
                              USSD
                          ==================================== */}
  
                          {method.ussd && (
  
                            <div
                              className="instruction-info-item"
                            >
  
                              <span>
                                USSD
                              </span>
  
  
                              <strong>
                                {
                                  method.ussd
                                }
                              </strong>
  
                            </div>
  
                          )}
  
                        </div>
  
  
                        {/* =====================================
                            STEPS
                        ====================================== */}
  
                        <div
                          className="instruction-steps"
                        >
  
                          <div
                            className="instruction-steps-title"
                          >
  
                            PAYMENT STEPS
  
                          </div>
  
  
                          <ol>
  
                            {method.steps.map(
                              (
                                step,
                                stepIndex
                              ) => (
  
                                <li
                                  key={
                                    stepIndex
                                  }
                                >
  
                                  <span
                                    className="instruction-step-number"
                                  >
  
                                    {
                                      stepIndex +
                                      1
                                    }
  
                                  </span>
  
  
                                  <span
                                    className="instruction-step-text"
                                  >
  
                                    {
                                      step
                                    }
  
                                  </span>
  
                                </li>
  
                              )
                            )}
  
                          </ol>
  
                        </div>
  
                      </div>
  
                    )
                  )}
  
                </div>
  
              )}
  
  
            {/* =================================================
                FALLBACK IF NO INSTRUCTIONS
            ================================================= */}
  
            {!isTanzania &&
              !countryInstructions &&
              currentAccount && (
  
                <div
                  className="payment-note"
                >
  
                  <div
                    className="note-icon"
                  >
  
                    <FaClock />
  
                  </div>
  
  
                  <div
                    className="note-content"
                  >
  
                    <span>
                      PAYMENT INFORMATION
                    </span>
  
  
                    <p>
  
                      Follow the international
                      transfer instructions provided
                      by your mobile money provider.
  
                    </p>
  
  
                    <small>
  
                      Make sure the recipient number,
                      amount and country are correct
                      before confirming.
  
                    </small>
  
                  </div>
  
                </div>
  
              )}
  
  
            {/* =================================================
                PAYMENT INSTRUCTION
            ================================================= */}
  
            <div
              className="payment-note"
            >
  
              <div
                className="note-icon"
              >
  
                <FaMoneyBillWave />
  
              </div>
  
  
              <div
                className="note-content"
              >
  
                <span>
                  PAYMENT INSTRUCTION
                </span>
  
  
                <p>
  
                  Please send exactly{" "}
  
                  <strong>
  
                    {formattedAmount}{" "}
                    {currency}
  
                  </strong>
  
                  {" "}to the account shown
                  above.
  
                </p>
  
  
                <small>
  
                  After completing the payment,
                  press the button below to
                  continue.
  
                </small>
  
              </div>
  
            </div>
  
  
            {/* =================================================
                PAYMENT STATUS
            ================================================= */}
  
            <div
              className="payment-status"
            >
  
              <div>
  
                <FaCheckCircle />
  
                <span>
                  Secure Payment
                </span>
  
              </div>
  
  
              <div>
  
                <FaClock />
  
                <span>
                  Processing Time: Instant
                </span>
  
              </div>
  
            </div>
  
  
            {/* =================================================
                COMPLETE BUTTON
            ================================================= */}
  
            <button
              type="button"
              className="continue-btn"
              onClick={
                handleComplete
              }
            >
  
              <span>
                Complete Payment
              </span>
  
  
              <FaArrowLeft
                className="continue-arrow"
              />
  
            </button>
  
          </div>
  
        </div>
  
      </div>
  
    );
  
  }